import PhysicalStore from './PhysicalStore';

import { IPhysicalStore } from '@interfaces/myProfileInterfaces';

import { getLabelFallback } from '@utils/utils';

interface Props {
    favouritesStores: IPhysicalStore[];
}

const MyStoresFavouritesStoresList = ({ favouritesStores }: Props): JSX.Element => {
    return (
        <div
            role="region"
            aria-label="My favourite stores list"
            className="my-stores_favourites-stores-list"
        >
            <div className="physical-stores">
                {favouritesStores.map(store => (
                    <PhysicalStore key={store.uniqueID} physicalStore={store} />
                ))}
            </div>
        </div>
    );
};

export default MyStoresFavouritesStoresList;
